(() => {
  class UniversalYumsShell extends HTMLElement {
    #abortController = new AbortController();

    connectedCallback() {
      const signal = this.#abortController.signal;
      this.addEventListener('click', this.#handleClick, { signal });
      document.addEventListener('keydown', this.#handleKeydown, { signal });
    }

    disconnectedCallback() {
      this.#abortController.abort();
    }

    #handleClick = event => {
      const closeControl = event.target.closest('[data-uy-drawer-close]');
      if (!closeControl) return;
      const details = this.querySelector('[data-uy-nav-details]');
      if (!details) return;
      details.removeAttribute('open');
      this.querySelector('[data-uy-nav-summary]')?.focus();
    };

    #handleKeydown = event => {
      if (event.key !== 'Escape') return;
      const details = this.querySelector('[data-uy-nav-details][open]');
      if (!details) return;
      details.removeAttribute('open');
      this.querySelector('[data-uy-nav-summary]')?.focus();
    };
  }

  if (!customElements.get('universal-yums-shell')) {
    customElements.define('universal-yums-shell', UniversalYumsShell);
  }
})();
